import { sendEvent } from 'constants/mixpanelHelper';
import { BULK_NOTIFY_EVENTS } from 'constants/trackingEvents';

export const sendBulkNotifyReviewsEvent = ({
  eventName = BULK_NOTIFY_EVENTS.BULK_NOTIFY_BUTTON,
  eventProperties = {},
}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendBulkNotifyReviewerTypeCheckboxEvent = ({
  eventName = BULK_NOTIFY_EVENTS.BULK_NOTIFY_REVIEWER_TYPE_CHECKBOX,
  eventProperties = {},
}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendBulkNotifyCloseReviewsEvent = ({
  eventName = BULK_NOTIFY_EVENTS.BULK_NOTIFY_CLOSE_REVIEWS,
  eventProperties = {},
}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendBulkNotifyClickNotifyEvent = ({
  eventName = BULK_NOTIFY_EVENTS.BULK_NOTIFY_REVIEWS,
  eventProperties = {},
}) => {
  sendEvent({ eventName, eventProperties });
};
